import React from 'react';

import { BasicField } from 'reactApp/components/Forms/_BasicField';

import { InputTrigger } from './InputTrigger/InputTrigger';

export class FieldTrigger extends React.Component {
    render() {
        const { name, label, ...otherInputProps } = this.props;

        return (
            <BasicField
                {...{
                    label,
                    name,
                    control: InputTrigger,
                    innerRef: (fieldNode) => {
                        this._fieldRef = fieldNode;
                    },
                    ...otherInputProps,
                }}
            />
        );
    }
}
